import React from 'react'
import CountUp from 'react-countup';

const FunFact = (props) => {
    return (

        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <h3><span><CountUp end={10} enableScrollSpy /></span>+</h3>
                            <h4>Years of Excellence</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <h3><span><CountUp end={100} enableScrollSpy /></span>+</h3>
                            <h4>Global Clients</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <h3><span><CountUp end={200} enableScrollSpy /></span>+</h3>
                            <h4>Successful Projects</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <h3><span><CountUp end={50} enableScrollSpy /></span>+</h3>
                            <h4>Skilled Professionals</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;




